import variables from './variables.module.scss';

export const { dashedBorder, ...colors } = variables;

export default colors;
